// import actions
import objetivoAction from './actions/objetivo'
import tipoObjetivoAction from './actions/tipoobjetivo'
import reporteAction from './actions/reporte'
import periodoAction from './actions/periodo'

const actions = {
  ...objetivoAction,
  ...tipoObjetivoAction,
  ...reporteAction,
  ...periodoAction,
}

export default {
  namespaced: true,
  actions,
}
